import { OutlineButton } from "@components/form";
import { AuthContext } from "@entities/auth/context";
import { clearReuestToken } from "@services/admin.fixransomware.com";
import { removeLocalToken } from "@services/local-storage";
import { useContext } from "react";
import { useTranslation } from "react-i18next";









export function LogoutButton() {
  const authContext = useContext(AuthContext);

  const {t} = useTranslation();

  return(
    <OutlineButton
      data-testid="auth-logout-button"
      variant="danger"
    >
      {t("features.auth.logout.button")}
    </OutlineButton>
    
  )

}

interface LogoutWrapperProps {
  children: React.ReactNode;
  onLogout: () => void;
}
export function LogoutWrapper(props: LogoutWrapperProps) {

  const logout = useLogout({
    onSuccess: props.onLogout
  })

  return (
    <button onClick={logout} className="w-full">
      {props.children}
    </button>
  );
}


interface useLogoutProps {
  onSuccess: ()=> void;
}
export function useLogout(props: useLogoutProps) {
  
  return ()=> {
    removeLocalToken();
    clearReuestToken();

    return props.onSuccess();
  }

}